import Colorpicker from './ColorPicker';
export default Colorpicker;
